import { createSlice } from '@reduxjs/toolkit'

export const globalSymbolSlice = createSlice({
    name: 'globalSymbol',
    initialState: {
        globalSymbol: {},
        globalSymbolID: null,
        orderPanelOpen: false,
        modifyPositionModalOpen: false,
        modifyPositionDetail:{},
        oneClickSymbolDetail:{}
    },
    reducers: {
        setGlobalSymbolsData: (state, action) => {
            state.globalSymbol = action.payload
        },
        setGlobalSymbolID: (state, action) => {
            state.globalSymbolID = action.payload
        },
        setTradeModalOpen: (state, action) => {
            state.orderPanelOpen = action.payload;
        },
        setModifyPositionOpen: (state, action) => {
            state.modifyPositionModalOpen = action.payload;
        },
        setModifyPositionDetail: (state, action) => {
            state.modifyPositionDetail = action.payload;
        },
        setOneClickSymbolDetail: (state, action) => {
            state.oneClickSymbolDetail = action.payload;
        },
    },
})
export const { setGlobalSymbolsData, setGlobalSymbolID, setTradeModalOpen, setModifyPositionOpen,setModifyPositionDetail,setOneClickSymbolDetail } = globalSymbolSlice.actions
export default globalSymbolSlice.reducer